module.exports = __webpack_public_path__ + "img/adirex.e096fe58.png";